var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',[_c('VFlex',[_c('h1',{staticClass:"primary--text mb-4"},[_vm._v("\n      "+_vm._s(_vm.$nt('heading'))+"\n    ")]),_c('VCard',{attrs:{"flat":""}},[_c('VFlex',[_c('AgencyOverviewAgentsTable')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }